module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_library.js
// module id = 225
// module chunks = 0